import React, {FunctionComponent, MouseEvent} from 'react'
import styled from 'styled-components'
import {WerfenColor, White} from "../../Constants/ColorChart";

const StyledDiv = styled.div`
  background: ${White};
  color: ${WerfenColor};
  font-size: 15px;
  font-weight: bold;
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: center;
  transition: all 300ms;
  display: block;
  border: 1px solid transparent;
  ${props => !props.miniSized && `width: 200px;`}
  margin: ${props => props.centered ? `10px auto;` : `10px 10px 0 0;`}
  &:hover {
    opacity: 0.9;
    cursor: pointer;
  }
  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
  &.disabled:hover {
    opacity: 0.5;
    pointer-events: none;
  }
`;


type MicrosoftButtonProps = {
    onClick: (event: MouseEvent<HTMLDivElement>) => void;
    centered?: boolean;
    miniSized?: boolean;
    onMouseDown?: () => void;
    Text: FunctionComponent<{}>;
    disabled?: boolean;
};

const MicrosoftButton: React.FC<MicrosoftButtonProps> = ({onClick, onMouseDown, centered, miniSized, Text, disabled}) => {
    return (
        <StyledDiv
            onClick={onClick}
            onMouseDown={onMouseDown}
            centered={centered}
            miniSized={miniSized}
            className={disabled ? 'disabled' : ''}
        >
            <Text/> Sign in with Microsoft
        </StyledDiv>
    );
};

export default MicrosoftButton;